import { getErrorMessage } from "../../../helper/getResponseMessage";
import axios from "../../../util/axiosconfig";
import { SORT_FILTER } from "../../../util/constants";
import { showError, showSuccess } from "../../../util/ShowStatus";
import { dataURLToFile } from "./helper/helperFunctions";

export const fetchTeams = async (
  setTeamsList: any,
  setTeamsListLoading: any,
  toast: any,
  date?: any
) => {
  try {
    const params: any = {};

    if (date) {
      params.allocatedDate = date;
    }
    setTeamsListLoading(true);
    const response = await axios.get(`health-and-safety/teams-list`, {
      params,
    });
    setTeamsList(response.data.result);
    setTeamsListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setTeamsListLoading(false);
    showError(error, toast);
  }
};

export const fetchTeamListing = async (
  setTeamListingData: any,
  filters: any,
  setTeamListingDataLoading: any,
  sortFilter: any,
  toast: any
) => {
  try {
    const params: any = {
      sortField: sortFilter.sortField,
      sortOrder:
        sortFilter.sortOrder === true ? SORT_FILTER.ASC : SORT_FILTER.DESC,
    };
    setTeamListingDataLoading(true);
    if (filters && filters.startDate && filters.endDate) {
      // Convert to UTC ISO string
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }
    const response = await axios.get("health-and-safety/leak-detection-form", {
      params,
    });
    setTeamListingData(response.data.result);
    setTeamListingDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setTeamListingDataLoading(false);
    showError(error, toast);
  }
};

export const fetchVehicles = async (
  setVehiclesList: any,
  setVehicleListLoading: any,
  toast: any
) => {
  try {
    setVehicleListLoading(true);
    const response = await axios.get(
      "tl-admin/vehicle/all?vehicleTypeID=4&page=-1"
    );
    setVehiclesList(response.data.result);
    setVehicleListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setVehicleListLoading(false);
    showError(error, toast);
  }
};

export const fetchDmaLocations = async (
  setDmaLocationsList: any,
  setDmaLocationsListLoading: any,
  toast: any
) => {
  try {
    setDmaLocationsListLoading(true);
    const response = await axios.get("health-and-safety/dma-location-list");
    setDmaLocationsList(response.data.result);
    setDmaLocationsListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setDmaLocationsListLoading(false);
    showError(error, toast);
  }
};

export const fetchKeyPlantsDetails = async (
  setKeyPlantsDetailsList: any,
  setKeyPlantsListLoading: any,
  toast: any
) => {
  try {
    setKeyPlantsListLoading(true);
    const response = await axios.get(
      `health-and-safety/key-plants-details-list?subModuleName=${encodeURIComponent(
        "Risk Assessment"
      )}`
    );
    setKeyPlantsDetailsList(response.data.result);
    setKeyPlantsListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setKeyPlantsListLoading(false);
    showError(error, toast);
  }
};

export const fetchActivitiesList = async (
  setActivitiesList: any,
  setActivitiesListLoading: any,
  toast: any
) => {
  try {
    setActivitiesListLoading(true);
    const response = await axios.get(
      `health-and-safety/activities-list?subModuleName=${encodeURIComponent(
        "Risk Assessment"
      )}`
    );
    setActivitiesList(response.data.result);
    setActivitiesListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setActivitiesListLoading(false);
    showError(error, toast);
  }
};

export const fetchClosestAandE = async (
  setClosestAandEList: any,
  setClosestAandEListLoading: any,
  toast: any
) => {
  try {
    setClosestAandEListLoading(true);
    const response = await axios.get("health-and-safety/closest-ae-list");
    setClosestAandEList(response.data.result);
    setClosestAandEListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setClosestAandEListLoading(false);
    showError(error, toast);
  }
};

export const fetchEmergencyContacts = async (
  setEmergencyContactsList: any,
  setEmergencyContactsListLoading: any,
  toast: any
) => {
  try {
    setEmergencyContactsListLoading(true);
    const response = await axios.get(
      "health-and-safety/emergency-contact-list"
    );
    setEmergencyContactsList(response.data.result);
    setEmergencyContactsListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setEmergencyContactsListLoading(false);
    showError(error, toast);
  }
};

export const fetchActionsList = async (
  setActionsList: any,
  setActionsListLoading: any,
  toast: any
) => {
  try {
    setActionsListLoading(true);
    const response = await axios.get(
      `health-and-safety/action-taken-list?subModuleName=${encodeURIComponent(
        "Risk Assessment"
      )}`
    );
    setActionsList(response.data.result);
    setActionsListLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setActionsListLoading(false);
    showError(error, toast);
  }
};

export const addReview = async (
  formID: any,
  formValues: any,
  signatureRef: any,
  setAddReviewLoading: any,
  setVisible: any,
  toast: any
) => {
  try {
    const formData = new FormData();
    if (formID) {
      formData.append("formID", formID);
    }
    if (formValues.reviewerDate) {
      formData.append("reviewerDate", formValues.reviewerDate);
    }
    if (formValues.reviewerName) {
      formData.append("reviewerName", formValues.reviewerName);
    }
    if (formValues.reviewerComment) {
      formData.append("reviewerComment", formValues.reviewerComment);
    }

    if (signatureRef.current && !signatureRef.current.isEmpty()) {
      const signatureDataUrl = signatureRef.current.toDataURL();
      const signatureFile = dataURLToFile(signatureDataUrl, `signature.png`);
      formData.append("signature", signatureFile);
    }

    setAddReviewLoading(true);
    const response = await axios.post(
      "health-and-safety/add-review",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    setAddReviewLoading(false);
    showSuccess(response.data.Message, toast);
    setVisible(false); // Close the modal after submission
    return response.data;
  } catch (err) {
    const error = getErrorMessage(err);
    setAddReviewLoading(false);
    showError(error, toast);
    return null;
  }
};

export const getFormByFormID = async (
  setFormData: any,
  setFormDataLoading: any,
  formIDParam: number,
  navigate: any,
  toast: any
) => {
  try {
    setFormDataLoading(true);
    const response = await axios.get(
      `health-and-safety/leak-detection-form-by-id?formID=${formIDParam}`
    );
    if (response.data.result.length === 0) {
      showError("Form not found", toast);
      setFormDataLoading(false);
      navigate("/layout/leak-detection/team-listing");
      return;
    }
    setFormData(response.data.result);
    setFormDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setFormDataLoading(false);
    showError(error, toast);
  }
};

export const getVehicleAssessmentDashBoardData = async (
  setVehicleAssessmentDashBoardData: any,
  setVehicleAssetDashBoardDataLoading: any,
  date: any,
  toast: any
) => {
  try {
    setVehicleAssetDashBoardDataLoading(true);
    const response = await axios.get(
      `health-and-safety/daily-vehicle-check-sheet-dashboard?date=${date}` // Assuming date is in the correct format
    );
    const filteredData = Array.isArray(response.data.result)
      ? response.data.result.filter(
          (vehicle: any) => vehicle.vehicleRegistration !== "No Vehicle"
        )
      : response.data.result;
    setVehicleAssessmentDashBoardData(filteredData);
    setVehicleAssetDashBoardDataLoading(false);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    setVehicleAssetDashBoardDataLoading(false);
    showError(errorMessage, toast);
  }
};
